export default __webpack_public_path__ + "static/media/call_icon.fe7bda33.svg";